import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { fetchNotifications } from "../api/notifications";
import { syncAppBadge } from "../lib/appBadge";

/**
 * Ikon lonceng notifikasi dengan penanda jumlah belum dibaca.
 * Dipakai di topbar setiap area role — termasuk aplikasi terapis yang
 * menerima notifikasi "Booking baru" saat pasien memesan. Jumlah yang sama
 * juga dipasang sebagai badge ikon aplikasi bila aplikasi sudah diinstal.
 */
export function NotificationBell({ segment }: { segment: string }) {
  const { data } = useQuery({
    queryKey: ["notifications"],
    queryFn: fetchNotifications,
    // Polling ringan agar notifikasi booking baru muncul tanpa reload halaman.
    refetchInterval: 30_000,
  });
  const unread = data?.unread;

  useEffect(() => {
    if (unread === undefined) return;
    syncAppBadge(unread);
  }, [unread]);

  const count = unread ?? 0;

  return (
    <Link
      to={`/${segment}/notifications`}
      className="btn-icon"
      title="Notifikasi"
      aria-label={count > 0 ? `Notifikasi, ${count} belum dibaca` : "Notifikasi"}
    >
      <Bell size={18} />
      {count > 0 ? (
        <span className="btn-icon-badge" aria-hidden>
          {count > 9 ? "9+" : count}
        </span>
      ) : null}
    </Link>
  );
}
